import { DropdownMenuLabel } from "@/components/ui/dropdown-menu";

interface UserDropdownHeaderProps {
  displayName: string;
  email?: string;
  whatsappNumber?: string | null;
  hasProfileName: boolean;
  tierName: string;
  hasPendingVerification: boolean;
  pendingLabel: string;
}

const UserDropdownHeader = ({
  displayName,
  email,
  whatsappNumber,
  hasProfileName,
  tierName,
  hasPendingVerification,
  pendingLabel,
}: UserDropdownHeaderProps) => {
  const subtitle = email || whatsappNumber || null;

  return (
    <DropdownMenuLabel className="px-3 py-3 font-normal">
      <div className="space-y-3">
        <div>
          <p className="font-heading text-base font-semibold leading-tight text-brand-ink">
            {displayName}
          </p>
          {subtitle ? (
            <p className="mt-1 truncate text-xs text-brand-slate">
              {subtitle}
            </p>
          ) : null}
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-md border border-brand-cloud bg-brand-mist px-2.5 py-1 text-xs font-medium text-brand-ink">
            {tierName}
          </span>
          {hasPendingVerification && (
            <span className="rounded-md border border-brand-cloud bg-white px-2.5 py-1 text-xs font-medium text-brand-slate">
              {pendingLabel}
            </span>
          )}
        </div>
      </div>
    </DropdownMenuLabel>
  );
};

export default UserDropdownHeader;
